export enum EHouseFloor {
  Main_Floor,
  Second_Floor,
  Basement,
}
